import React, { useState, useEffect } from "react";
import {
  Accordion,
  ButtonGroup,
  Button,
  Card,
  Modal,
  Tabs,
  Tab,
} from "react-bootstrap";
import { DATE_FORMATS, SOCIAL_SOURCES, TABS, VERTICALS } from "../../constants/app-constant";
import {
  formatDate,
  getDateFormat,
  getSocialApiDateFormat,
  groupBy,
} from "../../utility/common-methods";
import {
  NoFeedIcon,
  ModalCloseIcon,
  SocialBlogIcon,
  BlogIcon,
  BlogForumsIcon,
  SocialForumIcon,
} from "../Icons/icons.component";
import Loader from "../Shared/Loader";
import SocialFeedItem from "./SocialFeedItem";
import { httpGet } from "../../utility/requestHelper";
import { unifiedEnvConfig } from "../../constants/api-endpoint";
import Sticky from "react-sticky-el";
import ShareArticle from "../Shared/ShareArticle";
import { useSelector } from "react-redux";
import moment from "moment";

const defaultActiveKeys = { client: 1, competitor: 1, industry: 1 };
export const SocialFeedsModal = function ({
  show,
  selectedTabKey,
  onCancel,
  cancelButtonText,
  clientId,
  handleVerticalClick,
  selectedVertical,
  tabData,
  clientName,
  channelType
}) {
  const { V_SOCIAL, V_BLOG, V_FORUM } = VERTICALS;
  const [tabKey, setTabKey] = useState(selectedTabKey);
  const [tabFeeds, setTabFeeds] = useState([]);
  const [loaderState, setLoaderState] = useState(false);
  const [feedLoader, setFeedLoader] = useState(false);
  const [allSocialFeeds, setAllSocialFeeds] = useState([]);
  const [activeAccordian, setActiveAccordian] = useState();
  const [activeAccordianKey, setActiveAccordianKey] = useState("1");
  const [currentPage, setCurrentPage] = useState(1);
  const [hasData, setHasData] = useState(true);
  const [activeKeys, setActiveKeys] = useState(defaultActiveKeys);
  const [ungroupedData, setUngroupedData] = useState([]);
  const [selectedFeeds, setSelectedFeeds] = useState([]);
  const [selectedFeedGroup, setSelectedFeedGroup] = useState({});

  const perPage = 20;
  useEffect(() => {
    if (show) {
      getDailyFeeds();
    }
  }, [show, tabData]);

  const isEntityGroupSelected = (tName) => {
    return (
      selectedFeedGroup &&
      typeof selectedFeedGroup == "object" &&
      Object.keys(selectedFeedGroup).indexOf(tName) !== -1
    );
  };
  /** selectedEntityGroup is an state object used to keep track of selected topics.
   * It contains array of {topicName: topicFeeds} type entry. Which is added when selected, and
   * removed when deselected.
   */
  const handleTopicSelect = (tData) => {
    try {
      const { name, feeds } = tData;
      if (isEntityGroupSelected(name)) {
        const tempSFG = { ...selectedFeedGroup };
        let tempArr = [...selectedFeeds];
        feeds.forEach((element) => {
          tempArr = tempArr.filter((n) => {
            if (n.id !== element.id) return n;
          });
        });
        setSelectedFeeds(tempArr);
        delete tempSFG[name];
        setSelectedFeedGroup(tempSFG);
      } else {
        setSelectedFeedGroup({
          ...selectedFeedGroup,
          ...{
            [name]: feeds,
          },
        });
        setSelectedFeeds([...selectedFeeds, ...feeds]);
      }
    } catch (e) { }
  };
  /** Handles selection of single feed and its side effects.
   * Side Effects -if entire topic is selected and any of its single feed is deselected,
   * the topic group should be deleted from selectedFeedsGroup state object.
   * and only remaining feeds should be marked as selected.
   */
  const handleSingleFeedSelect = (feed) => {
    try {
      const selectedElmList = selectedFeeds.filter((n) => n.id == feed.id);
      const selectedElm = selectedElmList && selectedElmList[0];
      if (selectedElm) {
        const { entityName } = feed;
        if (isEntityGroupSelected(entityName)) {
          const tempSFG = { ...selectedFeedGroup };
          delete tempSFG[entityName];
          setSelectedFeedGroup(tempSFG);
        }
        let listWithoutCurrentFeed = selectedFeeds.filter(
          (n) => n.id != selectedElm.id
        );
        setSelectedFeeds(listWithoutCurrentFeed);
      } else {
        setSelectedFeeds([...selectedFeeds, feed]);
      }
    } catch (e) { }
  };

  const formatAndSetData = ({
    feed_list = [],
    entity_list = [],
    pagination = false,
    newFeeds = [],
    incrementPageCount = false,
  }) => {
    // formatting feeds data for the accordian.
    const entity_ids = getEntityIdList(entity_list);
    let newList = [];
    feed_list.forEach((feedObj) => {
      entity_ids.forEach((f) => {
        if (
          (feedObj.topic && feedObj.topic.id == f) ||
          (feedObj && feedObj.id == f)
        ) {
          const topic = feedObj.topic ? feedObj.topic : feedObj;
          topic.feed_count = feedObj.total ? feedObj.total : feedObj.feed_count;
          if (!pagination) {
            // initiating page count
            topic["page"] = 1;
            topic["pages"] = perPage;
            topic["feeds"] = feedObj.feeds;
          } else {
            topic["feeds"] = [...feedObj.feeds, ...newFeeds];
          }
          if (incrementPageCount) {
            topic["page"] = topic["page"] + 1;
            topic["pages"] = perPage;
          }

          newList.push(topic);
        }
      });
    });
    return newList;
  };

  const getEntityIdList = (array = []) => {
    return array.map((i) => (i.topic ? i.topic.id : i));
  };

  const getDailyFeeds = (verticalId = selectedVertical) => {
    setLoaderState(false);
    setLoaderState(true);
    httpGet(
      `${unifiedEnvConfig.SOCIAL_DAILY_FEED_COUNT_LIST.replace(
        "{clientId}",
        clientId
      )}&type=${verticalId}`
    )
      .then((response) => {
        const {
          data: { data },
        } = response;
        const array = data.length ? data.map((item) => item.topic) : [];
        setUngroupedData(array);
        data.forEach((item, index) => {
          if (array[index].id == item.topic.id) {
            array[index]["feed_count"] = item.feed_count;
          }
        });
        const activeEntityId = getEntityId(array);
        setActiveAccordianKey(activeEntityId);
        getAllSocialFeeds(data, verticalId);
        setLoaderState(false);
      })
      .catch((error) => {
        setHasData(false);
        setLoaderState(false);
        console.log(error);
      });
  };

  const getEntityId = (array, key) => {
    const currentTabKey = key ? key : selectedTabKey;
    const obj = array.filter((item) => (item.category == "client" && clientId == "11717"?"feeds":item.category) == currentTabKey)[0];
    return obj.id ? obj.id.toString() : "";
  };

  const showCount = (item) => {
    const data = tabData.find((i) => (i.topic_category == "client" && clientId == "11717"?"feeds":i.topic_category) == item.toLowerCase());
    return data ? data["category_count"] : "";
  };

  const renderTabData = () => {
    let renderKey = Object.keys(selectedFeedGroup);
    renderKey = renderKey && renderKey.length;
    if (Object.keys(tabFeeds).length > 0) {
      return (clientId == "11717"?['Feeds']:TABS).map((item, idx) => {
        return (
          <Tab
            key={idx}
            eventKey={item.toLowerCase()}
            title={clientId == "11717"?`${item}(${showCount(item)})`:`${item === "Competitor" && clientName ? "Subsidiaries" : item
              }(${showCount(item)})`}
          >
            {loaderState ? (
              <Loader />
            ) : (
              <>
                <div className="allFeedsAccordionWrap">
                  {(clientId == '11717'?tabFeeds.client?.length:tabFeeds[tabKey.toLowerCase()]) ? (
                    <Accordion
                      defaultActiveKey={1}
                      onSelect={(e) =>
                        setActiveKeys((prevState) => {
                          return {
                            ...prevState,
                            [tabKey.toLowerCase()]: e ? e : "",
                          };
                        })
                      }
                    >
                      <React.Fragment key={renderKey}>
                        {renderAccordian()}
                      </React.Fragment>
                    </Accordion>
                  ) : (
                    <div className="noFilterDataWrap no-feeds">
                      <NoFeedIcon size="sm" />
                      <h6>No Feeds Found</h6>
                    </div>
                  )}
                </div>
              </>
            )}
          </Tab>
        );
      });
    } else {
      return (
        <div className="noFilterDataWrap no-feeds">
          <NoFeedIcon size="sm" />
          <h6>No Feeds Found</h6>
        </div>
      );
    }
  };

  const renderFeeds = (feedsList, entityName, allArticleList = []) => {
    if (feedsList && feedsList.feeds.length && !loaderState) {
      return (
        <React.Fragment key={selectedFeeds && selectedFeeds.length}>
          {feedsList.feeds.map((item, index) => {
            return (
              <SocialFeedItem
                key={item.id}
                entityName={entityName}
                selectedVertical={selectedVertical}
                isModal
                {...item}
                clientId={clientId}
                onFeedSelect={handleSingleFeedSelect}
                feedsToShare={selectedFeeds}
                allArticleList={allArticleList}
              />
            );
          })}
        </React.Fragment>
      );
    } else {
      return (
        <div className="noFilterDataWrap no-feeds">
          <NoFeedIcon size="sm" />
          <h6>No Feeds Found</h6>
        </div>
      );
    }
  };

  const renderAccordian = () => {
    const data = groupBy(tabFeeds[clientId == '11717'?"client":tabKey], "name");
    const currrentTabData = Object.values(data) || [];
    let allArticleList =
      currrentTabData &&
      currrentTabData.map((ctd) => {
        if (!ctd || !ctd[0]) return null;
        const cv = ctd[0];
        return (
          cv.feeds &&
          cv.feeds.map(
            (ctdf) => `${ctdf.channel_type}/${ctdf.id}?entityName="${cv.name}"`
          )
        );
      });
    const tData = Object.keys(data).filter(
      (key, index) => data[key][0] && data[key][0].feed_count > 0
    );
    return tData && tData.length ? (
      Object.keys(data).map((key, index) => {
        const topicData = data[key][0];
        return (
          topicData &&
          topicData.feed_count && (
            <Card
              key={index}
              className={
                activeKeys[tabKey.toLowerCase()] == +(index + 1)
                  ? "customAccordionRow feedAccordion active"
                  : "customAccordionRow feedAccordion"
              }
            >
              <Sticky
                scrollElement=".allFeedsAccordionWrap"
                boundaryElement=".customAccordionRow"
                style={{ position: "relative" }}
                hideOnBoundaryHit={false}
              >
                <Card.Header>
                  <label className="inputWrap">
                    <input
                      type="checkbox"
                      onChange={() => handleTopicSelect(topicData)}
                      defaultChecked={isEntityGroupSelected(topicData.name)}
                    />
                    <span className="checkmark"></span>
                  </label>
                  <Accordion.Toggle
                    as={Button}
                    variant="link"
                    eventKey={index + 1}
                    onClick={() => accordianClick(topicData.id, index + 1)}
                  >
                    {topicData.name} {`(${topicData.feed_count || "0"})`}
                  </Accordion.Toggle>
                </Card.Header>
              </Sticky>
              <Accordion.Collapse eventKey={index + 1}>
                <Card.Body>
                  <>
                    {renderFeeds(
                      topicData,
                      topicData.name,
                      allArticleList.flat()
                    )}
                    {topicData.feeds.length < topicData.feed_count ? (
                      <div className="viewMoreBtnWrap">
                        {feedLoader ? (
                          <Loader />
                        ) : (
                          <Button
                            className="btn btnBlue viewMoreBtn"
                            onClick={() =>
                              showMoreClick(topicData.id, topicData)
                            }
                          >
                            View More
                          </Button>
                        )}
                      </div>
                    ) : null}
                  </>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          )
        );
      })
    ) : (
      <div className="noFilterDataWrap no-feeds">
        <NoFeedIcon size="sm" />
        <h6>No Feeds Found</h6>
      </div>
    );
  };

  const showMoreClick = (entityId, { page, name }) => {
    setFeedLoader(true);
    setActiveAccordianKey(entityId);
    setCurrentPage(currentPage + 1);
    let today = getSocialApiDateFormat(new Date());
    httpGet(
      unifiedEnvConfig.FETCH_SOCIAL_DASHBOARD_FEEDS.replace("{page}", page + 1)
        .replace("{perPage}", perPage)
        .replace("{topic_id}", entityId)
        .replace("{type}", selectedVertical)
        .replace("{from_date}", today)
        .replace("{to_date}", today)
        .replace("{client_id}", clientId),
      {},
      true
    )
      .then((response) => {
        const {
          data: { data },
        } = response;
        const previousFeedArray = tabFeeds[clientId == '11717'?"client":tabKey].filter(
          (i) => i.id == entityId
        );
        let previousFeedsListForSelectedTopic = [];
        if (previousFeedArray && previousFeedArray.length) {
          previousFeedsListForSelectedTopic = previousFeedArray[0].feeds
            ? previousFeedArray[0].feeds
            : [];
        }
        if (isEntityGroupSelected(name)) {
          let tempSelectedFeedGroup = { ...selectedFeedGroup };
          const newSelectedFeedList = [...selectedFeedGroup[name], ...data];
          tempSelectedFeedGroup[name] = newSelectedFeedList;
          setSelectedFeedGroup(tempSelectedFeedGroup);
          setSelectedFeeds([...selectedFeeds, ...data]);
        }
        formatAndSetData({
          feed_list:
            previousFeedArray && previousFeedArray.length
              ? previousFeedArray
              : data,
          entity_list: [entityId],
          pagination: true,
          newFeeds: data,
          incrementPageCount: true,
        });
        setTabFeeds(tabFeeds);

        setFeedLoader(false);
      })
      .catch((error) => {
        setFeedLoader(false);
        setAllSocialFeeds([]);
        console.log(error);
      });
  };

  const getAllSocialFeeds = (entity_list = [], verticalId) => {
    if (entity_list.length > 0 && verticalId) {
      let fromDate = clientId == '11717'?moment().subtract(1,"day").format("MM/DD/YYYY"):moment().format("MM/DD/YYYY");
      let today = getSocialApiDateFormat(new Date());
      setLoaderState(true);
      let url = `${unifiedEnvConfig.FETCH_SOCIAL_FEEDS}?searchParams[type]=${verticalId}&client_id=${clientId}&searchParams[from_date]=${fromDate}&searchParams[to_date]=${today}`;
      if(Number(channelType) !== 0 && clientId == '11717'){
        url+=`&searchParams[channel_type][]=${channelType}`
      }
      else if(Number(channelType) == 0 && clientId == '11717'){
        Object.keys(SOCIAL_SOURCES).forEach(sData => {
          url+=`&searchParams[channel_type][]=${SOCIAL_SOURCES[sData]}`
        })
      }
      const feedIdList = getEntityIdList(entity_list);
      feedIdList.forEach((t) => {
        url = `${url}&searchParams[topic_ids][]=${t}`;
      });
      httpGet(url, {}, true)
        .then((response) => {
          const {
            data: { data },
          } = response;
          const newDataList = formatAndSetData({
            feed_list: data,
            entity_list,
          });
          const formattedData = groupBy(newDataList, "category");
          setTabFeeds(formattedData);
          setLoaderState(false);
          setHasData(true);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const accordianClick = (id, key) => {
    setAllSocialFeeds([]);
    if (activeAccordian != id) {
      setCurrentPage(1);
      setActiveAccordian(id);
      setActiveAccordianKey(key);
    }
  };

  const tabClick = (tab) => {
    setTabKey(tab);
  };

  const verticalClick = (value) => {
    handleVerticalClick(value);
    setLoaderState(true);
    setTabFeeds([]);
    setHasData(false);
  };

  return (
    <Modal
      dialogClassName="customModal"
      className="allFeedsModal"
      show={show}
      onHide={() => onCancel(false)}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <span className="btnClose" onClick={() => onCancel(false)}>
          <ModalCloseIcon />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="modelHeader">
          <ButtonGroup
            className="smallToggleBtnGroup"
            // onClick={(e) => verticalClick(e.target.value)}
          >
            <Button
              className={
                selectedVertical === V_SOCIAL ? "tagBlue active" : "tagBlue"
              }
              value={V_SOCIAL}
            >
              <SocialBlogIcon />
              {Object.keys(SOCIAL_SOURCES).filter((sData) => (SOCIAL_SOURCES[sData] == channelType)).length?Object.keys(SOCIAL_SOURCES).find((sData) => (SOCIAL_SOURCES[sData] == channelType)):"Social"}
            </Button>
            {/* <Button
              className={
                selectedVertical === V_BLOG ? "tagViolet active" : "tagViolet"
              }
              value={V_BLOG}
            >
              <BlogIcon />
              Blogs
            </Button>
            <Button
              className={
                selectedVertical === V_FORUM ? "tagBrown active" : "tagBrown"
              }
              value={V_FORUM}
            >
              <SocialForumIcon />
              Forum
            </Button> */}
          </ButtonGroup>
          <ShareArticle
            article={selectedFeeds}
            isSocial
            onShareSuccess={() => {
              setSelectedFeeds([]);
              setSelectedFeedGroup({});
            }}
            {...clientId == "11717"?{fromDate:moment().subtract(1,'day').startOf("day").format("MM/DD/YYYY HH:mm:ss"),
              toDate:moment().endOf("day").format("MM/DD/YYYY HH:mm:ss")}:{}}
          />
        </div>
        {loaderState ? (
          <Loader />
        ) : (
          <>
            {hasData ? (
              <Tabs
                activeKey={tabKey}
                transition={false}
                onSelect={(tab) => tabClick(tab)}
              >
                {renderTabData()}
              </Tabs>
            ) : (
              <div className="noFilterDataWrap no-feeds">
                <NoFeedIcon size="sm" />
                <h6>No Feeds Found</h6>
              </div>
            )}
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

SocialFeedsModal.defaultProps = {
  show: false,
  onCancel: () => { },
  cancelButtonText: "Cancel",
};

export default SocialFeedsModal;
